import { useTransactionsFees } from "Api/Queries/Transactions/useTransactionsFees";
import { BaseTransactionFees } from "Components/Dashboard/TransactionFees/BaseTransactionFees";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { SettlementDownloadSection } from "Components/Transactions/UserTransactionFees/SettlementDownloadSection";
import { useCurrentUserRole } from "Hooks/useCurrentUserAccessRole";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { isSettlementUserRole } from "Types/settlements";
import { getRegionCurrency } from "Utils/CurrencyUtils";
import { endOfMonth, startOfMonth } from "date-fns";
import { Resources, useResource } from "Translations/Resources";
import { Stack, Typography } from "@mui/material";

export const MerchantTransactionFees = () => {
  const { t } = useResource();
  const dateFrom = startOfMonth(new Date()).toISOString();
  const dateTo = endOfMonth(new Date()).toISOString();
  const { data: fees, isLoading } = useTransactionsFees(dateFrom, dateTo);

  const currentUser = useLoggedInUser();
  const userRole = useCurrentUserRole();

  if (!currentUser?.partyPublicID || !isSettlementUserRole(userRole)) {
    return null;
  }

  return (
    <PrimaryPaper>
      <Stack gap={2} my={1}>
        <BaseTransactionFees
          amounts={fees?.totalFees ?? []}
          emptyStateCurrency={
            currentUser.region
              ? getRegionCurrency(currentUser.region)
              : undefined
          }
          isLoading={isLoading}
          title={t(Resources.Components.Settlements.TransactionCosts)}
          colorVariant="warning"
        />
        <Stack gap={1}>
          <Typography>
            {t(Resources.Components.Settlements.SettlementDownloadButton.Title)}
          </Typography>
          <SettlementDownloadSection
            partyPublicID={currentUser.partyPublicID}
            userRole={userRole}
          />
        </Stack>
      </Stack>
    </PrimaryPaper>
  );
};
